export default __webpack_public_path__ + "static/media/charm-s6.c58f169d.png";